import { SocialNetworkIcon } from '@/components/content/Footer/parts/LowerFooterSection/SocialNetworkIcon';
import { lowerFooterContainerIconsSx } from '@/components/content/Footer/parts/LowerFooterSection/styles/Box/lowerFooterContainerIcons';
import { lowerFooterSx } from '@/components/content/Footer/parts/LowerFooterSection/styles/Grid/lowerFooter';
import { lowerFooterContainerSx } from '@/components/content/Footer/parts/LowerFooterSection/styles/Grid/lowerFooterContainer';
import { lowerFooterTermsSx } from '@/components/content/Footer/parts/LowerFooterSection/styles/Grid/lowerFooterTerms';
import { styledTypographySx } from '@/components/content/Footer/parts/LowerFooterSection/styles/Typography/styledTypography';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { JsonEspotResponseType } from '@/data/utils/dataMapContent';
import { Box, Grid, Typography } from '@mui/material';

export const LowerFooterSection = ({ emsName }: { emsName: string }) => {
	const { jsonEspotData } = useContentRecommendation(emsName, true);
	const data = jsonEspotData as JsonEspotResponseType;

	return (
		<Grid container sx={lowerFooterSx}>
			<Grid item xs={12} md={12} lg={4} sx={lowerFooterContainerSx}>
				<Typography variant={'bodyBaseline'} sx={styledTypographySx}>
					{data?.title}
				</Typography>
				<Box sx={lowerFooterContainerIconsSx}>
					{data?.icons?.map((data, index) => (
						<SocialNetworkIcon key={index} icon={data.icon} url={data.url} />
					))}
				</Box>
			</Grid>
			<Grid item sx={lowerFooterTermsSx} xs={12} md={12} lg={8}>
				<Typography variant={'bodyBaseline'} sx={styledTypographySx}>
					{data?.copyright}
				</Typography>
			</Grid>
		</Grid>
	);
};
